import JsonP from 'jsonp'
import axios from 'axios'
import { message, notification } from 'antd'
import { createStore, combineReducers } from 'redux'
import loading from '../redux/reducers/loading'
import util from '@/util/common'
import store from '@/redux'
import * as types from '@/redux/types'
import NProgress from 'nprogress'
// import proxy from '@/proxy'

/**
 * 请求封装备注：noUrlFilter是否请求地址baseURL不增加'/adminapi'过滤,直接放行， noSuccessTag是否全部接收返回数据不判断res.success
 */

axios.defaults.baseURL = '/adminapi'
axios.defaults.withCredentials = true //让ajax携带cookie

// http request 拦截器
axios.interceptors.request.use(config => {
  if (config.noUrlFilter) {//noUrlFilter是否请求地址baseURL不增加'/adminapi'过滤,直接放行
    config.baseURL=''
  }else{
    config.baseURL='/adminapi'
  }
  return config;
}, error => { return Promise.reject(error) })

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    // const accessToken = util.getCookie('accessToken');
    // util.saveToken(accessToken)
    return response
  },
  (error) => {
    return Promise.reject(error?.response?.data)
  },
)

// 获取路由对象
// const history = useHistory()

export default class Axios {
  // 是否已经跳转登录页参数
  static isToLogin = false;
  static jsonp(options) {
    return new Promise((resolve, reject) => {
      JsonP(
        options.url,
        {
          param: 'callback',
        },
        function (err, response) {
          if (response.status == 'success') {
            resolve(response)
          } else {
            reject(response.messsage)
          }
        },
      )
    })
  }

  static ajax(url, method = 'GET', params = {}, time = 7200000, config = {}, shouldLoading = true) {
    const action = (bool) => {
      store.dispatch({
        type: types.LOADING,
        payload: { loading: bool },
      })
    }
    // shouldLoading && loading && action(true) // 显示loading动画
    shouldLoading && loading && NProgress.start()

    // console.log('loading加载')
    const apiToken = util.getToken()
    const data = method === 'GET' ? 'params' : 'data'
    if(config['Content-Type']=='application/x-www-form-urlencoded'){
      params=util.urlencodeFormData(params)
    }
    // const proxyConfig = proxy(process.env.NODE_ENV);
    // let baseApi = proxyConfig.proxyUrl
    // let baseApi = ''
    let configs = {}
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': config['Content-Type']||'application/json',
      Authorization: `Bearer ${apiToken}`,
      notMask: localStorage.getItem('notMask'),
    }
    config['Content-Type']&&(delete config['Content-Type'])
    configs = {
      headers,
      ...config,
    }
    const isTishi = (typeof config.isTiShi == 'undefined') ? true : config.isTiShi
    return new Promise((resolve, reject) => {
      axios({
        url,
        method,
        // baseURL:baseApi,
        withCredentials: true, //开启
        timeout: time,
        [data]: params,
        ...configs,
      })
        .then((response) => {
          if (response.status == '200') {
            const isFile = response.config.responseType === 'blob' // 是否为文件
            const successNoTag = response.config.noSuccessTag === true // noSuccessTag是否全部接收返回数据不判断res.success
            let res = response.data
            if (res.success) {
              // 项目公共状态管理,请求成功隐藏加载动画
              // loading && action(false)
              loading && NProgress.done()
              // console.log('loading隐藏1')
              if (!res.success && res.errMessage) {
                isTishi&&message.error(res.errMessage, 6)
                reject(response.data)
              } else {
                const data = res.data
                if (Array.isArray(data) && data.length && data.length > 0) {
                  var d = data[0]
                  if (d && d.errorMessage) {
                    let errmsg = ''
                    data.forEach((item) => {
                      errmsg += item.errorMessage + ','
                    })
                    res.success = false
                    isTishi&&message.error(errmsg, 6)
                    // console.log(errmsg);
                    reject(response.data)
                    return
                  }
                }
                resolve(res)
              }
            } else if (isFile) {
              // 返回的是文件
              const { data, headers } = response
              // todo 从 headers['content-disposition'] 提取文件名
              //   const fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
              const shouldDownload = response.config.shouldDownload
              if (!shouldDownload) {
                // 无需下载，直接返回
                resolve(res)
              } else {
                const fileName = Date.parse(new Date())
                const type = headers['content-type'].replace(/application\//, '')
                try {
                  util.downloadFile(data, fileName, type)
                } catch {
                  isTishi&&message.error('下载失败，请重试！', 6)
                }
                resolve(res)
              }


              // 项目公共状态管理,请求成功隐藏加载动画
              // loading && action(false)
              loading && NProgress.done()
            } else {
              if (!res.success && res.errMessage) {
                if (res.errCode && res.errCode.indexOf('JWT') >= 0) {
                  resolve(res) //token过期，交给程序处理
                } else if (res.errCode == 'TOKEN_ERROR' || res.errCode == 'TOKEN_EXPIRE' || res.errCode === 'AUTH_ERROR') {
                  if (this.isToLogin) return
                  this.isToLogin = true
                  // 跳转登录页
                  message.warning('会话超时，请重新登录')
                  util.cleanUserInfo()
                  setTimeout(() => {
                    window.location = '/login'
                  }, 800);
                } else {
                  isTishi&&message.error(res.errMessage, 6)
                  resolve(res)
                }
              } else if (!res.success && res.data) {
                if (res.data != null && res.data.length > 0) {
                  res.data.forEach((item) => {
                    isTishi&&message.error(item.errorMessage, 6)
                  })
                }
              } else if (successNoTag){
                resolve(res)
              }
              // 项目公共状态管理,请求成功隐藏加载动画
              // loading && action(false)
              loading && NProgress.done()
            }
          } else {
            // 项目公共状态管理,请求成功隐藏加载动画
            action(false)
            // console.log('loading隐藏3')
            reject(response.data)
          }
        })
        .catch((error) => {
          //   console.log('axios error', error)
          // 项目公共状态管理,请求成功隐藏加载动画
          // loading && action(false)
          loading && NProgress.done()
          // console.log('loading隐藏4')
          isTishi&&message.error('服务器响应超时，请刷新后重试！', 6)
          reject(error)
        })
    })
  }
}